'use strict';

var React = require('react');
var reactCropper_es = require('../../node_modules/react-cropper/dist/react-cropper.es.js');
var blobUtil_es = require('../../node_modules/blob-util/dist/blob-util.es.js');
var Dialog = require('../../DesignSystem/Feedback/Dialog/Dialog.js');
var DialogActions = require('../../DesignSystem/Feedback/Dialog/DialogActions.js');
var DialogContent = require('../../DesignSystem/Feedback/Dialog/DialogContent.js');
var DialogTitle = require('../../DesignSystem/Feedback/Dialog/DialogTitle.js');
var Button = require('../../DesignSystem/Inputs/Buttons/Button/Button.js');
var IconButton = require('../../DesignSystem/Inputs/Buttons/IconButton.js');
var makeStyles = require('../../DesignSystem/Styles/makeStyles.js');
var RotateLeft = require('../../IconsAndImages/Icons/RotateLeft.js');
var RotateRight = require('../../IconsAndImages/Icons/RotateRight.js');
var ZoomIn = require('../../IconsAndImages/Icons/ZoomIn.js');
var ZoomOut = require('../../IconsAndImages/Icons/ZoomOut.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"](function () {
  return {
    dialogContent: {
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    cropper: {
      height: 400,
      width: '100%'
    },
    zoomButtons: {
      marginTop: 8
    }
  };
});

var CropImageDialog = function CropImageDialog(_ref) {
  var open = _ref.open,
      _ref$dialogTitle = _ref.dialogTitle,
      dialogTitle = _ref$dialogTitle === void 0 ? 'Crop your image' : _ref$dialogTitle,
      _ref$saveButtonDisabl = _ref.saveButtonDisabled,
      saveButtonDisabled = _ref$saveButtonDisabl === void 0 ? false : _ref$saveButtonDisabl,
      _ref$saveButtonText = _ref.saveButtonText,
      saveButtonText = _ref$saveButtonText === void 0 ? 'Save' : _ref$saveButtonText,
      onSaveCroppedImage = _ref.onSaveCroppedImage,
      onClose = _ref.onClose,
      imageUrl = _ref.imageUrl,
      _ref$zoomTo = _ref.zoomTo,
      zoomTo = _ref$zoomTo === void 0 ? 0.5 : _ref$zoomTo,
      _ref$initialAspectRat = _ref.initialAspectRatio,
      initialAspectRatio = _ref$initialAspectRat === void 0 ? 1 : _ref$initialAspectRat,
      aspectRatio = _ref.aspectRatio,
      _ref$viewMode = _ref.viewMode,
      viewMode = _ref$viewMode === void 0 ? 1 : _ref$viewMode,
      _ref$minCropBoxHeight = _ref.minCropBoxHeight,
      minCropBoxHeight = _ref$minCropBoxHeight === void 0 ? 10 : _ref$minCropBoxHeight,
      _ref$minCropBoxWidth = _ref.minCropBoxWidth,
      minCropBoxWidth = _ref$minCropBoxWidth === void 0 ? 10 : _ref$minCropBoxWidth,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? false : _ref$background,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? true : _ref$responsive,
      _ref$autoCropArea = _ref.autoCropArea,
      autoCropArea = _ref$autoCropArea === void 0 ? 1 : _ref$autoCropArea,
      _ref$checkOrientation = _ref.checkOrientation,
      checkOrientation = _ref$checkOrientation === void 0 ? false : _ref$checkOrientation,
      _ref$guides = _ref.guides,
      guides = _ref$guides === void 0 ? false : _ref$guides;
  var classes = useStyles();
  var cropperRef = React.useRef(null);

  var handleSave = function handleSave() {
    var _cropperRef$current;

    var canvas = (_cropperRef$current = cropperRef.current) === null || _cropperRef$current === void 0 ? void 0 : _cropperRef$current.cropper.getCroppedCanvas({
      imageSmoothingQuality: 'high'
    });
    blobUtil_es.imgSrcToBlob(canvas.toDataURL()).then(function (blob) {
      var _cropperRef$current2;

      return onSaveCroppedImage(blob, (_cropperRef$current2 = cropperRef.current) === null || _cropperRef$current2 === void 0 ? void 0 : _cropperRef$current2.cropper);
    });
  };

  var zoomIn = function zoomIn() {
    var _cropperRef$current3;

    (_cropperRef$current3 = cropperRef.current) === null || _cropperRef$current3 === void 0 ? void 0 : _cropperRef$current3.cropper.zoom(0.1);
  };

  var zoomOut = function zoomOut() {
    var _cropperRef$current4;

    (_cropperRef$current4 = cropperRef.current) === null || _cropperRef$current4 === void 0 ? void 0 : _cropperRef$current4.cropper.zoom(-0.1);
  };

  var rotateLeft = function rotateLeft() {
    var _cropperRef$current5;

    (_cropperRef$current5 = cropperRef.current) === null || _cropperRef$current5 === void 0 ? void 0 : _cropperRef$current5.cropper.rotate(-90);
  };

  var rotateRight = function rotateRight() {
    var _cropperRef$current6;

    (_cropperRef$current6 = cropperRef.current) === null || _cropperRef$current6 === void 0 ? void 0 : _cropperRef$current6.cropper.rotate(90);
  };

  return React__default["default"].createElement(Dialog, {
    open: open
  }, React__default["default"].createElement(DialogTitle, null, dialogTitle), React__default["default"].createElement(DialogContent, {
    className: classes.dialogContent
  }, React__default["default"].createElement(reactCropper_es.Cropper, {
    ref: cropperRef,
    className: classes.cropper,
    src: imageUrl,
    zoomTo: zoomTo,
    initialAspectRatio: initialAspectRatio,
    aspectRatio: aspectRatio,
    viewMode: viewMode,
    minCropBoxHeight: minCropBoxHeight,
    minCropBoxWidth: minCropBoxWidth,
    background: background,
    responsive: responsive,
    autoCropArea: autoCropArea,
    checkOrientation: checkOrientation,
    guides: guides
  }), React__default["default"].createElement("div", {
    className: classes.zoomButtons
  }, React__default["default"].createElement(IconButton, {
    onClick: zoomOut
  }, React__default["default"].createElement(ZoomOut, null)), React__default["default"].createElement(IconButton, {
    onClick: zoomIn
  }, React__default["default"].createElement(ZoomIn, null)), React__default["default"].createElement(IconButton, {
    onClick: rotateRight
  }, React__default["default"].createElement(RotateRight, null)), React__default["default"].createElement(IconButton, {
    onClick: rotateLeft
  }, React__default["default"].createElement(RotateLeft, null)))), React__default["default"].createElement(DialogActions, null, React__default["default"].createElement(Button, {
    color: "secondary",
    onClick: onClose
  }, "CANCEL"), React__default["default"].createElement(Button, {
    color: "primary",
    onClick: handleSave,
    disabled: saveButtonDisabled
  }, saveButtonText)));
};

module.exports = CropImageDialog;
